<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_xiii"></a>Author’s Note</h2>
<p class="para1">For currency conversions, I have used the National Archive’s <em>Currency Converter: 1270–2017</em> to give an indication of the modern purchasing power of the sums described. The converter offers input on a five-year basis (i.e., 1900, 1905, 1910, 1915 and 1920) and, where the dates are not exact, I have rounded up to the nearest year. If multiple figures are quoted in succession, a conversion of only the first figure is included.</p>
<p class="indent-para">All individuals are referred to initially by their full name, and from then onwards by their surname. The exception to this is members of Churchill, Asquith and Scrymgeour’s family who, to avoid confusion, are referred to initially by their full name, but from then onwards by their first name.</p>
<p class="indent-para">The book follows a chronological timeline as much as possible. However, in some of the more thematic chapters it has been necessary, for both readability and argument, to include material from elsewhere in the timeline. Where this has occurred, it has been clearly marked. As a guideline to help readers, each chapter also contains an approximate date range for the events being discussed.</p>
<p class="indent-para">I have included references as endnotes and a select bibliography of materials I have consulted. Any and all mistakes, however, remain my own.<a id="page_xiv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?a50ead70